import { useRouter } from 'next/router'

const useUtmTags = (href, tags) => {

    if (!tags) return href

    //utm tags should work only for these pages
    const activePages = [
        'time-tracking',
        'team-management',
        'team-reporting',
        'employee-monitoring',
        'attendance-tracking',
        'employee-productivity-tracking-software',
        'time-tracking-app-for-enterprises',
        'time-tracking-app-for-small-businesses',
        'time-tracking-app-for-agencies',
        'time-tracking-app-for-teams',
        'time-tracking-app-for-freelancers',
        'screen-monitoring',
        'updates',
        'pricing'
    ];

    let url = false

    try {
        url = new URL(href, process.env.NEXT_PUBLIC_APP_URL)
    } catch (e) {
        return href
    }

    const router = useRouter()
    const page = router.pathname.substring(router.pathname.lastIndexOf('/') + 1)

    //if (!page || !activePages.includes(page)) return href

    const phpUrlEncode = (str) => {
        return encodeURIComponent(str).replace(/%20/g, '+')
    }

    tags = { ...tags, ...{ utm_source: page ? 'site' : 'main', utm_content: router.pathname } }

    if (!tags.utm_medium) {
        tags.utm_medium = router.asPath.includes('land') ? 'landing_page' : 'page'
    }
    
    Object.entries(tags).forEach(([key, value]) => {
        url.searchParams.append(key, value)
    })

    return url.toString()
};

export default useUtmTags

export const Utm = {
    MEDIUM: {
        PAGE: 'page',
        LANDING: 'landing_page',
        HEADER: 'header',
        FOOTER: 'footer'
    },
    CAMPAIGN: {
        BUTTON: 'button',
        LINK: 'link',
        LOGO: 'logo',
        BANNER: 'banner'
    }
};
